import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import { CodiceDestinatarioService } from '../../../../../services/codice-destinatario.service';

class FatturazioneConfermaController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$state',
        'store',
        'CodiceDestinatarioService',
        '$q'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private _codiceDestinatarioService: CodiceDestinatarioService,
        private $q: any
    ) {
        $scope.updateInProgress = true;
        ArchiSmallServices.enableFatturazione($rootScope.user)
            .then((response: any) => {
                $timeout(() => {
                    $rootScope.user = response;
                    store.set('user', response);
                    $scope.updateInProgress = false;
                    _codiceDestinatarioService.getCodiceDestinatario().then((result: any) => {
                        if (result.exists) {
                            $scope.codiceDestinatario = result.codiceDestinatarioDocument;
                            if ($scope.codiceDestinatario.code && $scope.codiceDestinatario.code.length > 0 && $scope.codiceDestinatario.code.substring(0, 1) === '*') {
                                $scope.codiceDestinatario.code = 'ACTKBBZ';
                            }
                        }
                    }, (error) => {
                        this.$q.reject(error);
                    });
                }, 2000);
            }, (error) => {
                $rootScope.alert('error', error);
            });
        $scope.selected = {
        };

        $scope.ok = () => {
            $state.go('home.fatturazione');
            this.close();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
    }
}

export const FatturazioneConfermaComponent: ng.IComponentOptions = {
    template: require('./fatturazione-conferma.html'),
    controller: FatturazioneConfermaController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/fatturazione-conferma/fatturazione-conferma.ts